import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { FetchResponse } from './fetch_response';
import { RequestInterceptor } from './request_interceptor';
import { getCookie, compact, metaContent, stringEntriesFromFormData, mergeEntries } from './lib/utils';
export var FetchRequest = /*#__PURE__*/function () {
  function FetchRequest(method, url) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, FetchRequest);

    this.method = method;
    this.options = options;
    this.originalUrl = url.toString();
  }

  _createClass(FetchRequest, [{
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var requestInterceptor, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                requestInterceptor = RequestInterceptor.get();

                if (!requestInterceptor) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return requestInterceptor(this);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
                _context.t1 = FetchResponse;
                _context.next = 13;
                return window.fetch(this.url, this.fetchOptions);

              case 13:
                _context.t2 = _context.sent;
                response = new _context.t1(_context.t2);

                if (!(response.unauthenticated && response.authenticationURL)) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", Promise.reject(window.location.href = response.authenticationURL));

              case 17:
                if (!(response.ok && response.isTurboStream)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return response.renderTurboStream();

              case 20:
                return _context.abrupt("return", response);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function perform() {
        return _perform.apply(this, arguments);
      }

      return perform;
    }()
  }, {
    key: "addHeader",
    value: function addHeader(key, value) {
      var headers = this.additionalHeaders;
      headers[key] = value;
      this.options.headers = headers;
    }
  }, {
    key: "fetchOptions",
    get: function get() {
      return {
        method: this.method.toUpperCase(),
        headers: this.headers,
        body: this.formattedBody,
        signal: this.signal,
        credentials: 'same-origin',
        redirect: this.redirect
      };
    }
  }, {
    key: "headers",
    get: function get() {
      return compact(Object.assign({
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.csrfToken,
        'Content-Type': this.contentType,
        Accept: this.accept
      }, this.additionalHeaders));
    }
  }, {
    key: "csrfToken",
    get: function get() {
      return getCookie(metaContent('csrf-param')) || metaContent('csrf-token');
    }
  }, {
    key: "contentType",
    get: function get() {
      if (this.options.contentType) {
        return this.options.contentType;
      } else if (this.body == null || this.body instanceof window.FormData) {
        return undefined;
      } else if (this.body instanceof window.File) {
        return this.body.type;
      }

      return 'application/json';
    }
  }, {
    key: "accept",
    get: function get() {
      switch (this.responseKind) {
        case 'html':
          return 'text/html, application/xhtml+xml';

        case 'turbo-stream':
          return 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml';

        case 'json':
          return 'application/json, application/vnd.api+json';

        default:
          return '*/*';
      }
    }
  }, {
    key: "body",
    get: function get() {
      return this.options.body;
    }
  }, {
    key: "query",
    get: function get() {
      var originalQuery = (this.originalUrl.split('?')[1] || '').split('#')[0];
      var params = new URLSearchParams(originalQuery);
      var requestQuery = this.options.query;

      if (requestQuery instanceof window.FormData) {
        requestQuery = stringEntriesFromFormData(requestQuery);
      } else if (requestQuery instanceof window.URLSearchParams) {
        requestQuery = requestQuery.entries();
      } else {
        requestQuery = Object.entries(requestQuery || {});
      }

      mergeEntries(params, requestQuery);
      var query = params.toString();
      return query.length > 0 ? "?".concat(query) : '';
    }
  }, {
    key: "url",
    get: function get() {
      return this.originalUrl.split('?')[0].split('#')[0] + this.query;
    }
  }, {
    key: "responseKind",
    get: function get() {
      return this.options.responseKind || 'html';
    }
  }, {
    key: "signal",
    get: function get() {
      return this.options.signal;
    }
  }, {
    key: "redirect",
    get: function get() {
      return this.options.redirect || 'follow';
    }
  }, {
    key: "additionalHeaders",
    get: function get() {
      return this.options.headers || {};
    }
  }, {
    key: "formattedBody",
    get: function get() {
      var bodyIsAString = Object.prototype.toString.call(this.body) === '[object String]';
      var contentTypeIsJson = this.headers['Content-Type'] === 'application/json';

      if (contentTypeIsJson && !bodyIsAString) {
        return JSON.stringify(this.body);
      }

      return this.body;
    }
  }]);

  return FetchRequest;
}();